import { healthURL } from 'constants/api'

import API from 'utils/api'


export default function fetchHealth() {
  return API.getData(healthURL)
}

